import * as React from 'react';
import { FormattedMessage } from 'react-intl';

import { IProductLabelProps } from '@notino/react-styleguide/dist/types/components/atoms/ProductLabel';

import { giftLabel } from '@components/Tags/model';
import { LabelWithIcon, StyledLabel } from '@components/Tags/styled';

import { messages } from '../../ProductTabContent/Reviews/messages';

export const GiftLabel: React.FC<Omit<IProductLabelProps, 'children'>> = ({
  labelType,
  labelStyle = giftLabel.style,
  icon,
}) => {
  return (
    <StyledLabel labelStyle={labelStyle} labelType={labelType} icon={icon}>
      <LabelWithIcon>
        {icon}
        <FormattedMessage {...messages.reviewMotivatedTitle} />
      </LabelWithIcon>
    </StyledLabel>
  );
};
